const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

export default currencyFormatter;


// WEBPACK FOOTER //
// ./src/components/utils/formatCurrency.ts